export const normalisePathname = (pathname: string): string => pathname.replace(/\/+$/, '') || '/'
